import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  data: any
}

@Component({
  selector: 'app-json-viewer-dialog',
  templateUrl: 'json-viewer.dialog.html',
  styleUrls: ['./json-viewer.dialog.scss']
})
export class JsonViewerDialogComponent {

  data: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
  ) { }

  ngOnInit() {
    this.data = JSON.stringify(this.dialogData, null, 4);
  }
}
